<div class="ticker-container">
  <div class="ticker-wrapper">
    <div class="ticker-items">
      <div class="ticker-item" *ngFor="let crypto of cryptoPairs">
        <span class="crypto-name">{{crypto.firstCurrencySymbol}}/{{crypto.secondCurrencySymbol}}</span>
        <span class="crypto-price">{{crypto.markPrice}}</span>
        <span class="crypto-change" [ngClass]="{'positive': crypto.change > 0, 'negative': crypto.change < 0}">
          {{crypto.change > 0 ? '+' : ''}}{{crypto.change}}%
        </span>
      </div>
    </div>
  </div>
</div>